// extracted by mini-css-extract-plugin
export default {"kebabButton":"ActionMenu_kebabButton__MeVYs","menu":"ActionMenu_menu__AvOts","dangerAction":"ActionMenu_dangerAction__iM4sS"};